export default
	{
		notificationMessage: "You have no message",
		// dashboard
		overviewTitle: "Overview",
		recentTitle: "Recent activity",
		logLabel_all: "All",
		logLabel_submissions: "New Submissions",
		logLabel_approvals: "Approvals & Publishing",
		logLabel_interactions: "User Interactions",
		logLabel_account: "Account Activity",
		statistic_submited_missions: "Submitted games",
		statistic_total_up_coins_earned: "Total Up coins earned",
		statistic_average_completion_rate: "Average game completion rate",

		// login form page
		confirmButtonLabel: "CONFIRM",
		userFieldLabel: "User",
		passwordFieldLabel: "Password",
		loginTitle: " Access your account",
		forgotPasswordLink: "Forgot your password?",
		loginButtonLabel: "LOGIN",
		loadingPopupMessage: " Please wait. The page is loading...",
		errorMessage_user_blocked: "User is blocked",
		errorMessage_invalid_grant: "Invalid username or password",

		errorMessage_invalid_login: "Invalid username or password",
		errorMessage_undefined:
			"Server error. <br /> Please wait a few minutes and try again",
		errorMessage_invalid_client:
			"Server error. <br /> Please wait a few minutes and try again",
		errorMessage_server_error:
			" Server error. <br /> Please wait a few minutes and try again",

		error_BPIP: "Invalid password",
		error_500: "Server error",
		error_401:
			" Server error. <br /> Please wait a few minutes and try again",
		error_400:
			" Server error. <br /> Please wait a few minutes and try again",

		emailField: "E-mail",
		resetPasswordHeader: "Change default password",
		setPasswordTitle: "Set your password",
		passwordOldField: "Old password",
		passwordField: "New password",
		confirmPasswordField: "Confirm new password",
		changePasswordLabel: "Change password",
		invalidPasswordMessage: "Invalid password",
		successMessageTitle: "Congratulations!",

		// forgot password
		forgotPasswordTitle: "Forgot password?",
		resetPasswordTitle: "Reset password",
		resetPasswordSuccessMessage: "Your password has been successfully changed",
		forgotPasswordMessage:
			"Please fill in your e-mail address and the last 6 digits of your personal ID number",

		// page name
		dashboardName: "Dashboard",
		profileName: "Settings",
		manageUsersName: "User Management",
		manageGamesName: "Game Management",
		manageRewardsName: "Reward Management",
		campaignName: "Campaign Management",
		logoutName: "Logout",

		gameNameRoLabel: "Name (RO) *",
		gameDescriptionRoLabel: "Description (RO) *",
		gameNameEnLabel: "Name (EN) *",
		gameDescriptionEnLabel: "Description (EN) *",
		rewardLabel: "Reward",
		productLabel: "Product",
		priceLabel: "Price (UpCoins)",
		stockLabel: "Stock",
		categoryLabel: "Category *",
		subcategoryLabel: "Subcategory",
		durationLabel: "Duration",
		startDateLabel: "Start date",
		hourLabel: "Start hour",
		imageLabel: "Media attachment",
		imageInfoLabel: "Click to browse for a file",
		gameDateError: "Start date must be before end date",
		groupMissionLabel: "Group mission",
		gameTypeComercialLabel: "Commercial game type",
		gamePlatformLabel: "Platform",
		gameUrlLabel: "Url",
		gameTypeComercialAmountLabel: "Group mission",
		partnerTargetLabel: "Target partner",
		partnerChooseLabel: "Choose partner",
		partnerSelectAllLabel: "Select all affiliates",
		partnerCodeTargetLabel: "CRM Code",
		partnerFiscalTargetLabel: "Fiscal Code",
		missionTargetAmountLabel: "Mission target (RON)",
		missionTargetCountLabel: "Mission target (nr.)",
		missionMinTransactionValueLabel: "Minimum Transaction Value",
		checkpointsLabel: "Set checkpoints",
		newCheckpointLabel: "New checkpoint",
		publishLabel: "Publish",
		saveLabel: "Save",
		approveLabel: "Approve",
		deleteLabel: "Delete",
		searchLabel: "Search",
		gameDeleteSuccess: "Game deleted successfuly",
		gameModifiedSuccess: "Game modified successfuly",
		gameApprovedSuccess: "Game approved successfuly",
		gameAddSuccess: "Game added successfuly",

		campaignLanguageLabel: "Language *",
		campaignLevelLabel: "Level *",
		campaignChannelLabel: "Channel *",
		campaignFilterLabel: "Filter",
		campaignTitleLabel: "Title *",
		campaignDescriptionLabel: "Body *",
		campaignLinkLabel: "Link",
		campaignSystemLabel: "System",
		language_RO: "Romanian",
		language_EN: "English",
		campaignCategory_marketing: "Marketing",
		campaignCategory_operational: "Operational",
		channel_push: "Push",
		futureCampaignsTitle: "Future campaigns",
		pastCampaignsTitle: "Past campaigns",

		campaignDeleteSuccess: "Campaign deleted successfuly",
		campaignModifiedSuccess: "Campaign modified successfuly",
		campaignAddSuccess: "Campaign added successfuly",

		imageWarning: "In order for the image to be correctly aligned on the mobile app, it needs to have 16:9 aspect ratio and jpeg/jpg/png file type.",
		categoryWarning: "By changing the category or subcategory the targeted partner list will be reset.",
		searchPartnerWarning: "The affiliate search is based on subcategory and product. Further filters (CRM code, fiscal code) will be applied only if they are filled in.",

		dailyDeleteSuccess: "Daily game deleted successfuly",
		dailyModifiedSuccess: "Daily game modified successfuly",
		dailyApprovedSuccess: "Daily game approved successfuly",
		dailyAddSuccess: "Daily game added successfuly",

		imageError: "Image format / aspect ratio (16:9) incorrect",


		rewardDeleteSuccess: "Reward deleted successfuly",
		rewardModifiedSuccess: "Reward modified successfuly",
		rewardApprovedSuccess: "Reward approved successfuly",
		rewardAddSuccess: "Reward added successfuly",
		rewardVouchersAddSuccess: "Reward vouchers added successfuly",
		partnerListUpdateSuccess: "Partners file was successfully uploaded to the server",

		errorMessage_UA1: "User data invalid",
		errorMessage_UA2: "Username email invalid",
		errorMessage_UA0: "First name or last name invalid",
		errorMessage_UA3: "User not admin",
		errorMessage_UA4: "User is admin",
		errorMessage_UA5: "New user password change",
		errorMessage_MA1: "Invalid mission type",
		errorMessage_MA2: "Active mission forbidden operation",
		errorMessage_MA3: "Incomplete mission",
		errorMessage_MA4: "Invalid checkpoints",
		errorMessage_MA5: "Invalid minimum tranzaction value",
		errorMessage_MA6: "Invalid affiliate",
		errorMessage_MA7: "Description too long",
		errorMessage_MA8: "Title too long",
		errorMessage_MA9: "Wrong image aspect ratio. It must be 16:9 ",
		errorMessage_MA10: "Wrong image format. It must be png/jpg/jpeg",
		errorMessage_MA11: "Wrong image size. It must be at most 256kb",
		errorMessage_MI1: "Missing category",
		errorMessage_MI2: "Missing end date",
		errorMessage_MI3: "Missing texts",
		errorMessage_MI4: "Missing title (ro)",
		errorMessage_MI5: "Missing title (en)",
		errorMessage_MI6: "Missing description (ro)",
		errorMessage_MI7: "Missing description (en)",
		errorMessage_MI8: "Missing url",
		errorMessage_MI9: "Missing reward (up coins)",
		errorMessage_MI10: "Missing target value",
		errorMessage_MI11: "Missing checkpoint type",
		errorMessage_MI12: "Missing checkpoint target value",
		errorMessage_MI13: "Missing checkpoint upcoins",
		errorMessage_MI14: "Missing checkpoints",
		errorMessage_MI15: "Image format incorrect",
		errorMessage_MI16: "Image size / format / aspect ratio (16:9) incorrect ",

		errorMessage_RA1: "Active reward",
		errorMessage_RA2: "Incomplete reward",
		errorMessage_RA3: "Active reward forbidden operation",
		errorMessage_RI1: "Missing price",
		errorMessage_RI2: "Missing texts",
		errorMessage_RI3: "Missing title (ro)",
		errorMessage_RI4: "Missing title (en)",
		errorMessage_RI5: "Missing description (ro)",
		errorMessage_RI6: "Missing description (en)",
		errorMessage_DA1: "Daily mission already exists",
		errorMessage_DA2: "Invalid daily mission",
		errorMessage_DA3: "Invalid stop date",
		errorMessage_SA1: "Invalid vouchers expiry date",
		errorMessage_SA2: "Invalid reward",
		errorMessage_SA3: "No stock for reward",

		errorMessage_INVALID_CHANNEL: "Invalid type",
		errorMessage_INVALID_LEVEL: "Invalid type",
		errorMessage_INVALID_START_DATE: "Invalid start date",
		errorMessage_INVALID_CONTENT: "Invalid templates",
		errorMessage_INVALID_LANGUAGE: "Invalid language",
		errorMessage_INVALID_TITLE: "Invalid title",
		errorMessage_INVALID_TITLE_LENGTH: "Title to long",
		errorMessage_INVALID_BODY: "Invalid body",
		errorMessage_INVALID_BODY_LENGTH: "Body to long",
		errorMessage_FORBBIDEN: "Forbbiden action",
		errorMessage_CAMPAIGN_NOT_FOUND: "Campaign not found",
		errorMessage_DAILY_CAMPAIGNS_EXCEDEED: "Campaign limit",
		errorMessage_ISSS: "Service unavailable",

		"errorMessage_ro Description": "No stock for reward",
		errorMessage_CATEGORY: "The category of the mission is mandatory",
		"errorMessage_VOUCHERS.FILE.EMPTY": "You must upload an excel file.",

		downloadLinkText: "Download model file",
		downloadPartnersFileText: "Download partners list file",

		gameType_N: "Simple game",
		gameType_Y: "Stacked game",

		confirmDeleteGameMessage: "Are you sure you want to delete the game?",
		confirmDeleteDailyMessage: "Are you sure you want to stop the daily mission?",

		confirmApproveGameMessage: "You are about to approve the game.<br /> It will be available starting at <b style='color: #f79000;'> {start_date} </b>. <br /> If you want another start date please change it before approving the game.",

		rewardType_general: "General",
		rewardType_unique: "Voucher",
		rewardType_multiben: "Multiben",

		product_11: "Up Dejun",
		product_12: "Up Vacanta",
		product_13: "Up Cadou",
		product_14: "Up Cultura",
		product_15: "Up Social",

		addUserSuccessMessage: "The user has been created successfully.",
		modifyUserSuccessMessage: "The user has been modified successfully.",
		deleteUserSuccessMessage: "The user has been deleted successfully",

		selectLabel: "Select...",
		uploadImageLabel: "Upload image",

		saveChangesLabel: "Save",
		cancelChangesLabel: "Cancel",

		// profile :
		lastNameLabel: "Name",
		firstNameLabel: "First name",
		emailLabel: "E-mail",
		changeImageLabel: "Modify",

		addUserLabel: "Add user",
		modifyUserLabel: "Modify user",

		addGameLabel: "New Game",
		addRewardLabel: "New Reward",
		dailyLabel: "Daily Mission",
		managePartnerLabel: "Manage Partners List",
		addCampaignLabel: "New Campaign",
		// friends
		sortBy_NEW: "Newest",
		sortBy_OLD: "Oldest",

		personModifySuccess: "Modificarea datelor s-a realizat cu succes.",

		// offer management
		campaignTitle: "Mobile App Notifications ",
		submittedGamesTitle: "Submitted games ",
		pendingGamesTitle: "Awaiting review ",
		submittedRewardsTitle: "Active Rewards",

		uploadVouchersInfoText: "Upload the Excel with the vouchers for this reward",
		expiryDateLabel: "Vouchers expiry date",
		uploadFileLabel: "Upload file (xls, xlsx)",
		uploadButtonLabel: "Upload",
		managePartnersTitleText: "Partners list",
		managePartnersInfoText: "Keep the affiliates file updated",


		confirmDeleteRewardMessage: "Are you sure you want to delete the reward?",

		// user management
		managementTitle: "Users",
		roleCompanyLabel: "Role: ",
		userRole_EDITOR: "Editor",
		userRole_ADMIN: "Admin",
		confirmDeleteUserMessage: "Are you sure you want to delete the user?",

		notificationsChooseOptionYes: "Yes",
		notificationsChooseOptionNo: "No",

		// Change Password Form
		passwordCriteria1Text: "At least 8 chracters",
		passwordCriteria2Text: "Minim one letter",
		passwordCriteria3Text: "Minim one number",
		// error messages
		errorMessage_BS12: "Invalid current password",
		errorMessage_500:
			" Server error. <br /> Please wait a few minutes and try again",
		// errorMessage_PSB1:
		// 	"Ai incercat autentificarea de prea multe ori cu o parola gresita. <br/> Contul tau este blocat {param} minute",
		// errorMessage_PSB2:
		// 	"Ai incercat sa te autentifici de prea multe ori cu o parola gresita. <br/> Contul tau este blocat {param} ore.",
		// errorMessage_PSB3:
		// 	"Ai incercat sa te autentifici de prea multe ori cu o parola gresita. <br/> Contul tau este blocat {param} ore si {param1} minute.",

		errorMessage_403: "Invalid username or password!",
		errorMessage_400: "Invalid username or password!",
		// Read More || Read less
		readMore: "More",
		readLess: "Less",

		// notificari
		deleteNotification: "Delete message",

		finishButtonLabel: "FINISH",
	}
	;
